// ============================================================
// THE FORGE REVIEW ROOM — `?stage=forge` (caP'n, 2026-09-22)
// ------------------------------------------------------------
// The REAL WilliesWorkshop, with a stand-in profile and no-op doors, so
// the 3D Forge (Workshop3D.jsx) can be walked and judged without logging
// in or crossing the Plaza. `&g=f` for the Lyraei body. No uid → no
// Firebase listeners (useEquippedCompanion stays empty), no writes.
// The ⬡ 3D button in the room's HUD is the real, persisted switch.
// ============================================================
import WilliesWorkshop from "./WilliesWorkshop";

const q = (() => { try { return new URLSearchParams(window.location.search); } catch (_) { return new URLSearchParams(); } })();
const say = (what) => () => console.log(`[forge stage] ${what}`);

export default function ForgeStage() {
  const profile = { name: "Aenarchist", gender: q.get("g") === "f" ? "f" : "m" };
  return (
    <WilliesWorkshop
      profile={profile}
      onExit={say("exit")}
      onForge={say("forge")}
      onCodex={say("codex")}
      onCheatChest={say("cheat chest")}
      onLibrary={say("library (The Dungeon)")}
    />
  );
}
